<main id="main-content" class="main-content">
  @if (report().report_status_id == 3) {
    <div class="report-message">
      <mat-icon class="message-icon">check</mat-icon>
      <div class="message-text">
        <h1>2500-8 Report has been Sent for Review!</h1>
        <h3>The report has been sent to the regional BAER coordinator for review.</h3>
        <button class="usa-button" [routerLink]="'/report-overview'"
        [queryParams]="{report_id: report().report_id}">View Report</button>
      </div>
    </div>
  }
  @if (report().report_status_id == 1) {
    <div class="report-message">
      <mat-icon class="message-icon">check</mat-icon>
      <div class="message-text">
        <h1>2500-8 Report is Ready for Final Submission</h1>
        <h3>The report is now in review and awaiting certification from the forest unit line officer.</h3>
        <button class="usa-button" [routerLink]="'/report-overview'"
        [queryParams]="{report_id: report().report_id}">View Report</button>
      </div>
    </div>
  }
  @if (report().report_status_id == 2) {
    <div class="report-message">
      <mat-icon class="message-icon">check</mat-icon>
      <div class="message-text">
        <h1>{{ report().baer_name }} 2500-8 Report Submitted Successfully!</h1>
        <h3>The report is now waiting for certification from the forest unit line officer(s) below:</h3>
        <div class="contact-contianer">
          @for (forest of report().forests; track forest; let i = $index) {
            <div class="contact-div">
              @if (forest.line_officer) {
                <mat-card class="contact-card">
                  <div>
                    <div class="user-cell-name">
                      <div class="user-icon">
                        <p>{{forest.line_officer.first_name[0]}}</p>
                      </div>
                      <a [routerLink]="['/user']" [queryParams]="{user_id: forest.line_officer?.user_id}"
                      class="user-name">{{forest.line_officer.first_name + " " + forest.line_officer.last_name}}</a>
                    </div>
                    <div class="user-cell-details">
                      @for (role of forest.line_officer.baer_roles; track role) {
                        <mat-chip>{{ role }}</mat-chip>
                      }
                      <div class="details-number"><mat-icon>phone</mat-icon> {{(forest.line_officer.phone_num | phone) ||
                      "--"}}
                    </div>
                    <div class="details-email"><mat-icon>email</mat-icon>{{forest.line_officer.email}}</div>
                    <div class="details-email"><mat-icon>location_on</mat-icon>{{ forest.forest_name }}</div>
                  </div>
                </div>
              </mat-card>
            }
          </div>
        }
      </div>
      <button class="usa-button" [routerLink]="'/report-overview'"
      [queryParams]="{report_id: report().report_id}">View Report</button>
    </div>
  </div>
}
</main>